export const isLikelyHevcVideo = (video) => {
  const metadata = video?.media_metadata || video?.h264_fallback_metadata || {};
  const values = [
    video?.codec,
    video?.browser_playback,
    video?.codec_string,
    metadata.codec,
    metadata.source_codec,
    metadata.browser_playback,
    metadata.codec_string,
  ].filter(Boolean).map(value => String(value).toLowerCase());
  return Boolean(video?.requires_hevc_support || metadata.requires_hevc_support || values.some(value => (
    value.includes('h265') || value.includes('hevc') || value.includes('hev1') || value.includes('hvc1')
  )));
};

export const getHevcSupportSnapshot = async () => {
  if (typeof document === 'undefined') return { supported: false, reason: 'browser_unavailable' };
  const node = document.createElement('video');
  const nativeSupport = [
    'video/mp4; codecs="hev1.1.6.L93.B0, mp4a.40.2"',
    'video/mp4; codecs="hvc1.1.6.L93.B0, mp4a.40.2"',
    'video/mp4; codecs="hev1"',
    'video/mp4; codecs="hvc1"',
  ].some(type => Boolean(node.canPlayType(type)));
  let webCodecsSupport = false;
  if (typeof VideoDecoder === 'function' && typeof VideoDecoder.isConfigSupported === 'function') {
    try {
      const result = await VideoDecoder.isConfigSupported({ codec: 'hev1.1.6.L93.B0', hardwareAcceleration: 'prefer-hardware' });
      webCodecsSupport = Boolean(result?.supported);
    } catch {
      webCodecsSupport = false;
    }
  }
  return {
    supported: nativeSupport || webCodecsSupport,
    nativeSupport,
    webCodecsSupport,
    reason: nativeSupport || webCodecsSupport ? 'supported' : 'hevc_not_reported_supported',
  };
};

export const hasRenderedVideoFrames = (videoElement) => {
  if (!videoElement) return false;
  if (Number(videoElement.videoWidth || 0) > 0 && Number(videoElement.videoHeight || 0) > 0) {
    const quality = typeof videoElement.getVideoPlaybackQuality === 'function'
      ? videoElement.getVideoPlaybackQuality()
      : null;
    if (!quality || Number(quality.totalVideoFrames || 0) > 0) return true;
  }
  return false;
};